import { storyblokEditable } from "@storyblok/react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useRouter } from "next/compat/router";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import { StoryblokPicture } from "@components/core/Storyblok/StoryblokImage";

function LargeBannerImage({ blok }) {
  const router = useRouter();
  const user = useCurrentUser();
  const userGroup = user?.user_group;

  function sendTrackerData() {
    const defaultEventData = {
      tracking_name: "homeLargeBannerImage",
      page: router?.asPath,
      link: blok.link?.url,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  if (!blok) return null;

  return (
    <section
      key={blok._uid}
      {...storyblokEditable(blok)}
      className="storyblok-home-container-full-width"
    >
      <Link
        href={blok.link?.url}
        prefetch={false}
        onClick={() => sendTrackerData()}
      >
        <StoryblokPicture
          className="large-banner-image"
          desktopSrc={blok.background_image_desktop?.filename}
          mobileSrc={blok.background_image_mobile?.filename}
          loading="eager"
        />
      </Link>
    </section>
  );
}

export default LargeBannerImage;
